import { render, staticRenderFns } from "./TemplateCategories.vue?vue&type=template&id=46efefc2&scoped=true"
import script from "./TemplateCategories.vue?vue&type=script&lang=js"
export * from "./TemplateCategories.vue?vue&type=script&lang=js"
import style0 from "./TemplateCategories.vue?vue&type=style&index=0&id=46efefc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46efefc2",
  null
  
)

export default component.exports